import getSettings from "./get-settings.js";

export default {
	getSettings,
};
